import { takeLatest, take, call, select, put } from 'redux-saga/effects';
import { actions as userMessaging } from '../userMessaging';
import { getCommunicationsSummaryIfNeeded } from './sagas';
import { GET_COMMUNICATION_DATA } from './actions';

import {
  getCampaigns,
  GETTING_CAMPAIGNS_SUCCEEDED,
  GETTING_CAMPAIGNS_FAILED
} from '../campaign/actions';

// TODO: move this into a helper - and update campaign and template roots to use the new helper as well.
import { actions as UserActions } from '../user';
function* waitForUserReady() {
  const userReady = yield select(store => store.user.ready);
  if (!userReady) {
    yield take(UserActions.LOGIN_READY);
  }
}

/* APP FLOW - Communication */
function* GetCommunicationsSummarySaga() {
  yield takeLatest(GET_COMMUNICATION_DATA, function*(action) {
    yield call(waitForUserReady);
    yield put(getCampaigns());
    yield takeLatest(GETTING_CAMPAIGNS_SUCCEEDED, function*(action) {
      yield call(getCommunicationsSummaryIfNeeded, action);
    });
  });
}

function* CommunicationHandleFailuresSaga() {
  yield takeLatest([GETTING_CAMPAIGNS_FAILED], function*(action) {
    yield put(userMessaging.setMessageForFailedAction(action));
  });
}

export default [GetCommunicationsSummarySaga, CommunicationHandleFailuresSaga];
